import { Ticket, CreateTicketMessage, TicketMessage } from "../types";
import { api } from "./base.api";

export const ticketAPI = {
  createTicket: async (ticket: Partial<Ticket>) => {
    const response = await api.post("/tickets", ticket);
    return response.data;
  },

  getTickets: async (page: number = 1, limit: number = 5) => {
    const response = await api.get<{
      tickets: Ticket[];
      pagination: {
        total: number;
        page: number;
        limit: number;
        pages: number;
      };
    }>(`/tickets?page=${page}&limit=${limit}`);
    return response.data;
  },

  getTicket: async (id: string) => {
    const response = await api.get<Ticket>(`/tickets/${id}`);
    return response.data;
  },

  updateTicket: async (id: string, ticket: Partial<Ticket>) => {
    const response = await api.patch<Ticket>(`/tickets/${id}`, ticket);
    return response.data;
  },

  addMessage: async (id: string, message: CreateTicketMessage) => {
    const response = await api.post<TicketMessage>(
      `/tickets/${id}/messages`,
      message
    );
    return response.data;
  },

  closeTicket: async (id: string) => {
    const response = await api.post(`/tickets/${id}/close`);
    return response.data;
  },
};
